module.exports = __webpack_public_path__ + "img/fe605b5.png";